import React from "react";
import { ToastContainer } from "react-toastify";

const ToastProvider: React.FC = () => (
  <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
);

export default ToastProvider;
